import { render } from "./SelectedSettingsList.vue?vue&type=template&id=327c1250&ts=true"
import script from "./SelectedSettingsList.vue?vue&type=script&lang=ts"
export * from "./SelectedSettingsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__